<template>

    <div id="recover">

        <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">

            <div v-if="loaded">
                <div class="sm:mx-auto sm:w-full sm:max-w-md text-brand-500">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" preserveAspectRatio="none" class="fill-current h-14 mx-auto">
                        <path d="M476.791 135.986L250.075 5.818 50.9 120.812l425.765 245.379V283.2l-288.49-165.674 58.07-33.522 230.546 132.357zM23.209 136.478l423.717 244.204-196.635 113.499L23.578 363.287v-77.109l228.319 131.107 58.05-33.506L23.209 219.091z"></path>
                    </svg>
                    <h2 class="mt-2 text-center text-3xl text-gray-900">
                        {{ app_name }}
                    </h2>
                </div>

                <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">


                    <div class="mb-4 flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-4 py-2 rounded tracking-wide shadow items-center text-error-400" v-if="form.hasError()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <p class="text-error-700 text-sm">
                            {{ form.getErrorMessage() }}
                        </p>
                    </div>

                    <div class="mb-4 flex border-l-4 border-brand-500 bg-brand-50 text-gray-700 px-4 py-2 rounded tracking-wide shadow items-center text-brand-400" v-if="form.successful()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <p class="text-brand-900 text-sm">
                            {{ form.getSuccessMessage() }}
                        </p>
                    </div>

                    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">

                        <h3 class="font-medium mb-4">Reset your {{ app_name }} account</h3>

                        <p class="text-gray-500 text-sm mb-4">
                            Enter the email address associated with your account, and we'll send you a link to reset your password.
                        </p>

                        <form class="space-y-6" action="#" method="POST" @submit.prevent="form.recoverAccount()">
                            <div class="form-control" :class="{ 'form-control-error': form.fieldHasErrors('email') }">
                                <label for="email">Email address</label>
                                <input id="email" name="email" type="email" autocomplete="email" required v-model="form.data.email">
                                <span v-if="form.fieldHasErrors('email')">{{ form.getFieldError('email') }}</span>
                            </div>

                            <div>
                                <button type="submit" class="btn w-full justify-center">
                                    Proceed
                                </button>
                            </div>
                        </form>

                    </div>

                    <div class="flex text-right justify-end mt-4 text-sm text-gray-500">
                        Don't have an account?&nbsp;<router-link :to="{ name: 'signup' }">Sign Up</router-link>
                    </div>

                </div>
            </div>


            <Loading v-else></Loading>
        </div>

    </div>

</template>

<script>
import {User} from "../../app/Auth/User";
import Loading from "../Support/Loading";

export default {
    name: "Recover",
    props: {
        app_name: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            form: null,
            loaded: false,
            password_type: 'password'
        }
    },
    components: {
        Loading
    },
    methods: {
        recoverAccount() {
            let vm = this;

            vm.form.recoverAccount().then(result => {
                setTimeout(function () {
                    vm.$router.push({ name: 'login' });
                }, 3000);
            });
        }
    },
    mounted() {
        let vm = this;
        new Promise(resolve => {
            vm.form = new User();
            resolve(true);
        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


